
import { ref, computed } from 'vue';
import { searchService } from '@/api/search.service';

export class SuggestionItem{
    SuggestedName: string;
    Url: string;

    constructor(item:any){
        this.SuggestedName = item.SuggestedName ?? item.suggestedName ?? "";
        this.Url = item.Url ?? item.url ?? "";
    }
}

interface Props {
    placeholder?: string;
    searchLabel?: string;
}

/**
 * Verwaltet die Suchlogik mit Auto-Vervollständigung
 * Zuständig für Eingabeverarbeitung, Vorschläge und Benutzerinteraktionen
 */
export function useSearchList(
    props: Props,
    emit: (event: 'search', term: string) => void
) {
    const searchTerm = ref('');
    const suggestions = ref<SuggestionItem[]>([]);
    let blurTimeout: number | undefined;

    const MINIMUM_SEARCH_LENGTH = 4;
    const BLUR_DELAY = 200;

    /**
     * Labels mit Fallback-Werten
     */
    const placeholder = computed(() => props.placeholder ?? 'Stichwort');
    const searchLabel = computed(() => props.searchLabel ?? 'Suchen');

    /**
     * Lädt Suchvorschläge basierend auf der Eingabe
     */
    const loadSuggestions = async (term: string) => {
        try {
            const response = await searchService.suggestPraeparatName(term);
            const suggests = response.suggests?? [];
            suggests.forEach((suggest:any) => {
                suggestions.value = suggestions.value.concat(new SuggestionItem(suggest));
            });
        } catch (error) {
            console.error('Fehler beim Laden der Suchvorschläge:', error);
            suggestions.value = [];
        }
    };

    /**
     * Verarbeitet Eingabeänderungen und lädt Vorschläge
     */
    const onInput = async () => {
        if (searchTerm.value.length >= MINIMUM_SEARCH_LENGTH) {
            await loadSuggestions(searchTerm.value);
        } else {
            clearSuggestions();
        }
    };

    /**
     * Führt die Suche aus und versteckt Vorschläge
     */
    const emitSearch = () => {
        clearSuggestions();
        emit('search', searchTerm.value);
    };

    /**
     * Wählt einen Vorschlag aus und führt die Suche aus
     */
    const selectSuggestion = (item: SuggestionItem) => {
        // searchTerm.value = item.SuggestedName;
        clearSuggestions();
        window.location.href = item.Url;
        // emit('search', item.SuggestedName);

};
    /**
     * Entfernt alle Suchvorschläge
     */
    const clearSuggestions = (suggestionList = suggestions) => {
        suggestions.value = [];
        if (blurTimeout) {
            clearTimeout(blurTimeout);
            blurTimeout = undefined;
        }
    };

    /**
     * Verzögerte Ausblendung der Vorschläge beim Fokus-Verlust
     */
    const onBlur = () => {
        blurTimeout = window.setTimeout(() => {
            clearSuggestions();
        }, BLUR_DELAY);
    };
    
    return {
        searchTerm,
        suggestions,
        placeholder,
        searchLabel,
        onInput,
        emitSearch,
        selectSuggestion,
        clearSuggestions,
        onBlur
    };
}